module.exports = __webpack_public_path__ + "static/media/icon-menu-down-active.547f06c5.svg";